import first from 'lodash/first'
export const isTrending = (article, trending) => {
    return article && article.link && trending && trending.filter && first(trending.filter(trend => article.link.url === trend.url ));
}




// WEBPACK FOOTER //
// ./src/utils/article.js